import { componentsMixins } from "core/materialLoader"
import layoutComponent from "materials/layout/render/index.vue"
import emptyLayoutComponent from "materials/layout/render/index.vue"
import cxPageLayoutComponent from "materials/pageLayoutComponent/render/index.vue"
const componentsMap = {
  ...componentsMixins,
  layoutComponent,
  emptyLayoutComponent,
  cxPageLayoutComponent
}
const GridCacheCompoent = {
  props: {
    cache: {
      type: Boolean,
      default: false
    },
    shape: String
  },
  render(h) {
    if (this.cache) {
      return this._cacheNode
    } else {
      this._cacheNode = null
      this._cacheNode = h(componentsMap[this.shape], {
        props: {
          ...this.$attrs
        },
        on: {
          ...this.$listeners
        }
      })
      return this._cacheNode
    }
  }
}
export default GridCacheCompoent